module.exports = {
  gsacover: {
    title: 'God Sees All - Aloupeeps-  Cover',
    description: 'A cover done by the Enna Alouette Fan server for Enna Alouette on her Birthday',
    warnings: 'Music played is a cover of: ChibaNyan, Ehtyria - God Sees All',
    lead: 'Dippy',
    credits: '\nVocals:\nAiri, Arkazu, Verm, Hiya! Kk, koshka-sova, AllSoonNoDairy, MugList, Ralphy, EksPtt, Sen, Dippy, Kuroshi, Altina, troosh, MiikeMQ, DarkDisasterKid, Coronetto, TG, obviebear, CPU Violet, Soul Jam, Razy, Domo Espresso\n \n Cover Inst by: Akello\n \n Mixing:\n DJCVRRY\n SasuCrow\n \n MV: Wick (Andy)\n \n Art:\n Keektang\n Leef\n 6InchSenpai\n MinniJay\n \n Leads:\n Dippy (Main Lead)\n SasuCrow (sample cutting)\n Domo Espresso (wrangling Dippy)',
    video: 'https://www.youtube.com/embed/cUKC7S6ka3M',
  },
  aloucast: {
    title: 'Aloupeeps Happy Birthday Enna Podcast Special',
    description: 'Happy Birthday Podcast for our favorite songbird!',
    lead: 'Domo Espresso, DarkDisasterKid, BONER',
    credits: 'Domo Espresso, DarkDisasterKid, BONER',
    video: null,
  },
  bakingrelay: {
    title: 'Birthday Cake Baking Relay',
    description: 'A relay type video with the Aloupeeps baking a cake for Enna\'s Birthday',
    lead: 'BONER',
    credits: 'AllSoonNoDairy, Altina, Arkteezy, Bingu, Boner, Broney Stinson, Crono, Domo Espresso, Jo-さん, Nuit [夜], Petras Emergency Food, Soul Jam, Thapperson Apple, Zer0Pendragon6, DarkDisasterKid',
    video: 'https://www.youtube.com/embed/clPBkMIE5qw',
  },
  rickroll: {
    title: 'An Aloupeep Birthday Anthem',
    description: 'An acapella tribute to wish our wonderful songbird a Happy Birthday!',
    warnings: 'Gameplay clips from Enna\'s previous streams',
    lead: 'Soul Jam',
    credits: '\nVideo: Soul Jam\nArrangement: Soul Jam\nAlternate Lyrics: Soul Jam\nMix: DJ CVRRY / Soul Jam\nVocals: \naletheia / AllSoonNoDairy / Arkazu / coronetto / DarkDisasterKid / Dippy (Professional Simp) / Domo Espresso / EksPtt / hiya! kk / MugList / Ralphy / Sasu Crow / Soul Jam / TG / troosh / Verm\nArtwork: MinniJay\nAloupeep Art: Leef / Keektang / 6InchSenpai / Professor Nobu',
    video: 'https://www.youtube.com/embed/b1G0RxdLcGA',
  },
  bdayvoices: {
    title: 'Happy birthday from the Aloupeeps',
    description: 'The Aloupeeps wishing an Happy Birthday to our dear Songbird.',
    warnings: 'Using this BGM for the video 🎧Happy Birthday Jazz Waltz - E\'s Jammy Jams [Copyright FREE Music]',
    lead: 'Altina (Main Lead, Video Editing), SasuCrow (Sounds mixing)',
    credits: 'Airi, Altina, Corochan, Crono, Decimater001, EmotionalSupportStrappon, Frank, JeEztli , Jo-さん, KakaTan, Kuroshi, MugList, Professor Nobu, Sasu Crow, Shoiti, Yui-chan, Zer0Pendragon6',
    video: 'https://www.youtube.com/embed/_hsSGAXwssA',
  },
  bdaydance: {
    title: 'Birthday Dance',
    description: 'Enna\'s Birthday present from Soramari and kaochiicos',
    warnings: 'Music played is Enna Alouette trying to sing: Kanaria - KING',
    lead: 'Soramari',
    credits: 'Soramari, kaochiicos',
    video: 'https://www.youtube.com/embed/SVVGD3XM9So',
  },
};
